import type { Session } from 'next-auth';

import type { ProxySession } from './types/next-auth';

function getSessionTokens(session?: Session | null) {
  const px = session?.user?.px as ProxySession | null | undefined;
  return {
    tk: px?.tk ?? session?.user?.tk,
    rtk: px?.rtk ?? session?.user?.rtk,
  };
}

export function getSessionAuthToken(session?: Session | null) {
  return getSessionTokens(session).tk;
}

export function mountAuthHeaders(session?: Session | null) {
  if (!session) {
    return {};
  }

  const { tk, rtk } = getSessionTokens(session);

  if (!tk) {
    return {};
  }

  return {
    Authorization: `Bearer ${tk}`,
    ...(rtk ? { RefreshToken: rtk } : {}),
  };
}
